<template>
    <SpinnerContainer v-if="request.kind === 'pending'" />
    <div
        v-else-if="request.length > 0"
        class="flex w-full"
    >
        <Promotions
            :promotions="request"
        />
    </div>
    <SdsEmptyScreen
        v-else
        :title="$t('promotion.available.empty_title')"
        :description="$t('promotion.available.empty_description')"
        class="promotions-list__empty"
    />
</template>

<script>
    import { isMobileLayout } from '@superbet-group/web.lib.vue-utilities';
    import { promotionsService } from '@app/promotions/services/PromotionsService';
    import { RouteName } from '@app/router/constants/RouteName';
    import sanitizeQuerySelector from '@core/utils/url/sanitizeQuerySelector';
    import { errorGuard } from '@utils/ErrorGuard';
    import Promotions from './Promotions';
    import { SdsEmptyScreen } from '@superbet-group/web.lib.ui-components';

    const DEFAULT_OFFSET = -80;
    const MOBILE_OFFSET = -40;

    export default {
        name: 'PromotionsContainer',
        props: {
            groupName: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                request: null,
            };
        },
        async created() {
            await this.fetchPage();
            this.scrollToPosition();
        },
        watch: {
            async $route() {
                await this.fetchPage();
                this.scrollToPosition();
            },
        },
        methods: {
            async fetchPage() {
                this.request = {
                    kind: 'pending',
                };
                await errorGuard(async () => {
                    this.request = await promotionsService.getPromotions(this.groupName);
                }, {
                    onError: () => {
                        this.request = null;
                        this.$router.push(
                            {
                                name: RouteName.App.NotFound,
                            },
                        );
                    },
                });
            },
            scrollToPosition() {
                if (this.$route.hash) {
                    let offset = DEFAULT_OFFSET;
                    if (isMobileLayout()) {
                        offset += MOBILE_OFFSET;
                    }
                    this.$scrollTo(sanitizeQuerySelector(this.$route.hash), { offset });
                }
            },
        },
        components: {
            Promotions,
            SdsEmptyScreen,
        },
    };
</script>
